export const isTrailerSolutionsQrUrl = (qrUrl: URL): boolean => {
    const vueUrl = new URL(process.env.VUE_APP_TACLITE_ROOT_URL);
    return qrUrl.host === vueUrl.host;
};

export const extractScannedTrailerId = (qrUrl: URL): string => {
    const values = qrUrl.toString().split('/');
    return values[values.length - 1];
};
